<template>
  <nly-content-wrapper>
    <nly-breadcrumb>
      <nly-breadcrumb-item text="Matérias " active />
      <!-- <nly-breadcrumb-item text="breadcrumb"  /> -->
      <!-- <nly-breadcrumb-item text="alunos"  active />  -->
    </nly-breadcrumb>
    <nly-card class="text-center">
      <h1>Matérias</h1>
    </nly-card>
    
    <nly-content>
      <nly-row>
        <nly-col>
            <div class="container col-md-6 col-lg-6 col-xs-12">
               
               <div v-for="(lista,index) in Materias" :key="index" class=" callout callout-info row">
                   <div class="col-md-9 col-xs-9">
                       <h5>{{lista.nome}}</h5>
                        <p>{{lista.nome_professor}}</p>
                   </div>
                   <div class="col-md-3 col-xs-3">
                       <button @click="Router(lista)" class="bt btn-primary">ENTRAR</button>
                   </div>
                  
                </div>
               
            </div>
            
        </nly-col>
      </nly-row>
    </nly-content>
  </nly-content-wrapper>
</template>

<script>
export default {
  data() {
    return {
    lista_materias:[]
    };
  },
  created(){
this.AllMaterias()
  },
  computed:{
        Materias(){
            return this.$store.state.materias.AllMaterias;
        }
  },
  methods:{
     AllMaterias() {
        this.$store.dispatch("AllMaterias", 2160)
            
            // this.lista_materias = this.$store.state.materias.AllMaterias;
            //  console.log(this.lista_materias);
            // this.$snotify.success("Funfou");
           
       
    },
    
      Router(value){
        this.$store.dispatch("GetDadosMateria", value)
        this.$router.push({ name: "aulas" });
      }
  }

};
</script>
